import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';
import Advantages from './components/Advantages';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: '韩漫画免费阅读',
        url: 'http://costrebate.com/',
        description: '韩漫画免费阅读平台，提供下拉式阅读体验、海量韩国漫画资源、及时更新。看漫画下拉式，好看的韩国漫画大全。',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://costrebate.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: 'ManhwaFun',
        url: 'http://costrebate.com/',
        description: '韩国漫画网站 - 韩漫画免费阅读平台',
        sameAs: ['http://costrebate.com/'],
      },
      {
        '@type': 'WebPage',
        name: '韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全',
        description: '韩漫画免费阅读,看漫画下拉式,好看的韩国漫画大全,韩国漫画网站。支持免费阅读韩漫和下拉式观看，包含众多好看的漫画大全，更新及时体验流畅。',
        isPartOf: { '@type': 'WebSite', name: 'ManhwaFun' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://costrebate.com/' },
        ],
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全_韩国漫画网站"
        description="韩漫画免费阅读,看漫画下拉式,好看的韩国漫画大全,韩国漫画网站。这个韩国漫画网站支持免费阅读韩漫和下拉式观看，包含众多好看的漫画大全，更新及时体验流畅，让您轻松追更和享受阅读乐趣。"
        keywords="韩漫画免费阅读,看漫画下拉式,好看的韩国漫画大全,韩国漫画网站,韩国漫画,免费韩漫"
        canonical="http://costrebate.com/"
        ogTitle="韩漫画免费阅读_看漫画下拉式_好看的韩国漫画大全_韩国漫画网站"
        ogDescription="韩漫画免费阅读,看漫画下拉式,好看的韩国漫画大全,韩国漫画网站。支持免费阅读韩漫和下拉式观看，包含众多好看的漫画大全，更新及时体验流畅。"
        ogUrl="http://costrebate.com/"
        schemaData={schemaData}
      />

      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <LatestUpdates />
        <PopularRanking />
        <Advantages />
        <Testimonials />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}